// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__PZ9YR","Primary":"Button_Primary__rjuIZ","IsActive":"Button_IsActive__LXp3C","IsSmaller":"Button_IsSmaller__SGn3H"};